import type { MouseEvent } from 'react'

/**
 * A primary click with no modifier keys — the only click a link may take
 * over in place (opening a modal). Ctrl/Cmd/Shift/Alt clicks and middle
 * clicks keep the browser's own behavior: a new tab or window.
 */
export function isPlainClick(event: MouseEvent<HTMLElement>): boolean {
  return (
    event.button === 0 &&
    !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
  )
}
